const user_routes = {
    checkUser: "/checkUser",
    captchaMews: "/captchaMews",
    sendOtp: "/otp/send",
    confirmOtp: "/otp/verify",
    sendOtpFarabi: (fund_id) => `/rayan/sendOtp${fund_id}`,
    sendFundOtp: (fund_id) => `user/funds/${fund_id}/sendOtp`,
    signUp: "/auth/signUp",
    setPassword: "/auth/setPassword",
    signIn: "/auth/signIn",
    customerInfo: (fund_id) => `/rayan/customerInfo${fund_id}`,
    patchFund: (fund_id) => `/user/funds/${fund_id}`,
    forget: "/forgetPassword",
    referredBy: "/user/referredBy",
    checkSejam: "/user/isSejami",
    addCustomerFarabi: "/rayan/createCustomer",
    createInvestor: (fund_id) => `/user/funds/${fund_id}/createInvestor`,
    profileInfo: "/user/profile",
    acceptAgreement: "/user/acceptAgreement",
    sejamInfo: "/user/sejamInfo",
    banksList: "/user/banks",
    addCard: "/user/bank/cards",
    logout: "/user/logout",
    viewBankAccountPage: "/user/viewBankAccountPage",
    funds: "/funds",
    userFunds: "/user/funds",
    userCards: "/user/bank/cards",
    paymanChartTrans: (card_id) => `/user/report/chart/transaction/${card_id}`,
    paymanListTrans: (card_id) => `/user/report/list/transaction/${card_id}`,
    cardFunds: (card_id) => `/user/bank/cards/${card_id}/fund`,
    updateCardStatus: (card_id) => `/user/bank/cards/${card_id}`,
    deleteCard: (card_id) => `user/bank/cards/${card_id}`,
    cardDetails: (card_id) => `/user/bank/cards/${card_id}`,
    fundDetails: (fund_id) => `/fund/${fund_id}`,
    updateCard: (card_id) => `/user/bank/cards/${card_id}`,
    gateways: "/ipg/list",
    sell: "/order/sell",
    buy: "/order/buy",
    changePassword: "/user/changePassword",
    editProfile: "/user/profile/update",
    fundHistory: (fund_id) => `/fund/${fund_id}/history`,
    farabiBanks: "/funds/banks",
    buyReceipt: "/user/bankTransfer",
    notifications: "/notification/list",
    notificationsRead: "/notification/read",
    unreadNotifs: "/notification/countUnRead",
    pinvestBanks: "pinvest/banks",
    fundBalance: (fund_id) => `/user/fund/${fund_id}/balance`,
    userFundStatement: (fund_id) => `/user/fund/${fund_id}/statement`,
    userFundsProfits: (fund_id) => `/user/fund/${fund_id}/profit`,
    orderChart: (fund_id) => `user/report/chart/fund/${fund_id}`,
    orderList: (fund_id) => `user/report/list/fund/${fund_id}`,
    receiptImage: (order_id) => `/user/receipt/image/${order_id}`,
    pep: (id) => `/pep/${id}`,
    contractHash: "/user/contractHash",
    checkCardService: "/cards/transfer-menu",
    nexoSendOTP: "/user/cms/sendOtp",
    nexoVerifyOTP: "/user/cms/verifyOtp",
    nexoUserInfo: "/user/cms/getUserInfo",
    nexoDD: "/user/cms/dd/sendOtp",
    nexoDDVerify: "/user/cms/dd/verifyOtp",
    nexoPCRequest: "/user/cms/requestPhysicalCard",
    nexoActiveCard: "/user/cms/activationCard/sendOtp",
    nexoActiveCardVerify: "/user/cms/activationCard/verifyOtp",
    paymentLinkInfo: (uuid) => `/payments/links/${uuid}`,
    getPaymentLink: "/payments",
    refund: (fund_id) => `/refund/${fund_id}`,
    allCardFunds: "/user/bank/cards/funds",
    deleteOrder: (order_id) => `/orders/${order_id}`,
    getFundCustomer: (fund_id) => `/user/fund/${fund_id}/getCustomer`,
    sendContractOtp: (fund_id) => `/user/funds/${fund_id}/sendContractOtp`,
    verifyContract: (fund_id) => `/user/funds/${fund_id}/verifyContractOtp`,
    disableFund: (fund_id) => `/user/funds/${fund_id}`,
    registerConsultations: (admin_id = null) =>
        `/consultations/register${admin_id ? "/" + admin_id : ""}`,
    farabiReservationDaysStatus: "/consultations/getDaysStatus",
    farabiReservationIntervalStatus: "/consultations/getIntervalStatusByDay",
    farabiReservationSubmit: "/consultations/createReservation",
    getLinkReceiptInfo: (id) => `/user/orders/${id}`,
    downloadFile: "/user/downloadFile",
    addDescription: (order_id) => `/orders/${order_id}`,
    orderReceiptInfo: (order_id) => `/orders/${order_id}`,
    loginLogs: "/user/logs",
    apContract: "/user/bank/cards/registerApp",
    profitsChart: (fund_id) => `/user/fund/${fund_id}/dailyProfit`,
    profitsMonth: (fund_id) => `/user/fund/${fund_id}/monthlyProfit`,
    NPSState: "/nps/isRatedRecently",
    NPSCancel: "/nps/insert",
    NPSInsert: "/nps/insert",
    addRepeatSell: "/order/repeatSell",
    getRepeatSells: "/order/getRepeatSell",
    deleteRepeatSell: (sell_id) => `/order/repeatSell/${sell_id}`,
    monthlyDeposit: (fund_id) => `/user/fund/${fund_id}/monthlyDeposit`,
    depositsTable: (fund_id) => `/user/fund/${fund_id}/dailyDeposit`,
    commissionsTable: (fund_id) => `/user/fund/${fund_id}/dailyCommission`,
    vouchersList: "/user/voucher",
    useVoucher: (voucher_id) => `/user/voucher/${voucher_id}`,
    fundBanks: (fund_id) => `/funds/${fund_id}/banks`,
    pinvestFundBanks: (fund_id) => `/pinvest/${fund_id}/banks`,
    updateOrderFund: (order_id) => `/orders/buy-orders/${order_id}`,
    nexoForget: "/user/cms/pinCardOtp",
    nexoForgetVerify: "/user/cms/pinCardOtpVerification",
    nexoReplica: "/user/cms/replicaCardOtp",
    nexoReplicaVerify: "/user/cms/replicaCardOtpVerification",
    nexoTransactions: "/user/cms/assetTransactions",
    changeProfitPercent: (fund_id) => `/user/funds/${fund_id}/profitPercentChange`
};

const admin_routes = {
    signIn: "/core/auth/signIn",
    profileInfo: "/core/manager/profile",
    unreadNotifs: "/core/notification/countUnRead",
    roleList: "/core/role/list",
    roleDelete: (role_id) => `/core/role/delete/${role_id}`,
    addRole: "/core/role/create",
    permissions: "/core/permission/list",
    editRole: (role_id) => `/core/role/update/${role_id}`,
    managersList: "/core/manager/list",
    managersTotal: "/core/manager/total",
    activeManager: (user_id) => `/core/manager/activation/${user_id}`,
    deactiveManager: (user_id) => `/core/manager/deactivation/${user_id}`,
    managerAdd: "/core/manager/create",
    managerFunds: "/core/manager/funds",
    customersList: "/core/user/list",
    customersTotal: "/core/user/total",
    customerProfile: (customer_id) => `/core/user/profile/${customer_id}`,
    customerProfileEdit: (customer_id) =>
        `/core/user/profile/update/${customer_id}`,
    logout: "/core/manager/logout",
    customerActive: (customer_id) => `/core/user/activation/${customer_id}`,
    customerDeactive: (customer_id) => `/core/user/deactivation/${customer_id}`,
    customerCards: (customer_id) => `/core/user/bank/cards/${customer_id}`,
    managersAll: "/core/manager/all",
    customerCardStatus: (card_id) => `/core/user/bank/cards/${card_id}`,
    customerCardChart: (bank_card_id) =>
        `/core/user/report/chart/transaction/${bank_card_id}`,
    banksList: "/core/banks",
    editProfile: "/core/manager/profile/update",
    sendOtp: "/otp/send",
    confirmOtp: "/otp/verify",
    fundBalance: (fund_id) => `/core/balance/fund/${fund_id}`,
    fundWithdrawChart: (fund_id) => `/core/report/chart/fund/${fund_id}`,
    changePassword: "/core/manager/changePassword",
    customerFundReportChart: (user_id, fund_id) =>
        `/core/user/${user_id}/report/chart/fund/${fund_id}`,
    customerFunds: (customer_id) => `/core/user/funds/${customer_id}`,
    customerFundBalance: (customer_id, fund_id) =>
        `/core/user/${customer_id}/balance/fund/${fund_id}`,
    managerEdit: (manager_id) => `/core/manager/update/${manager_id}`,
    userPermissions: "/core/permissions",
    googleAuthenticatorSecretKey: "/core/manager/googleAuthenticatorSecretKey",
    googleAuthenticatorCheckCode: "/core/manager/googleAuthenticatorCheckCode",
    transactionslist: "/core/transaction/getTransactionList",
    transactionDetails: (id) => `/core/transaction/getOrderDetails/${id}`,
    updateTransStatus: "/core/orders",
    recreateOrder: "/core/fund/buy/recreate",
    notifications: "/core/notification/list",
    notificationsRead: "/core/notification/read",
    messages: "/core/message/list",
    channelsList: "/core/message/channelList",
    changeManagerPassword: (user_id) =>
        `/core/manager/changePassword/sub/${user_id}`,
    customerUpdateParent: (customer_id) =>
        `/core/user/update/parent/${customer_id}`,
    userSearch: "/core/user/search",
    sendMessage: "/core/message/create",
    messageGet: (message_id) => `/core/message/${message_id}`,
    messageUpdate: (message_id) => `/core/message/update/${message_id}`,
    ordersList: "/core/report/orders",
    sellReportList: "/core/fund/getSellOrderList",
    commissionTotal: (fund_id) =>
        `/core/fund/${fund_id}/getAdminTotalCommission`,
    commissionChart: (fund_id) =>
        `/core/fund/${fund_id}/getManagerCommissionChart`,
    configs: "/core/config",
    configChange: (id) => `/core/config/${id}`,
    customerDetail: (id) => `/core/user/detail/${id}`,
    sendInviteLink: "/core/message/inviteLink",
    inviteLinkList: "/core/message/invite/list",
    downloadFile: "/core/downloadFile",
    reportFundTotal: "core/report/deposit/fund/total",
    reportFundTotalChart: "core/report/deposit/fund/chart/total",
    reportDepositsSuccess: "/core/report/deposit/user/total",
    reportDepositsSuccessChart: "/core/report/deposit/user/chart/total",
    reportAccountsCount: "/core/report/bankCard/total",
    reportAccountsCountChart: "/core/report/bankCard/chart/total",
    reportTransactionsIPGCount: "/core/report/ipg/transaction/total",
    reportTransactionsIPGCountChart: "/core/report/ipg/transaction/chart/total",
    reportDepositFundTotal: "/core/report/deposit/fund/total",
    reportDepositFundTotalChart: "/core/report/deposit/fund/chart/total",
    reportUnitTotal: "/core/report/deposit/fund/total/unit",
    reportUnitTotalChart: "/core/report/deposit/fund/chart/total/unit",
    reportCommissionTotal: "/core/report/fund/commission/total",
    reportCommissionTotalChart: "/core/report/fund/commission/chart/total",
    reportOrdersCount: "/core/report/fund/order/total",
    reportOrdersCountChart: "/core/report/fund/order/chart/total",
    reportOrdersAmount: "/core/report/fund/order/amount/total",
    reportOrdersAmountChart: "/core/report/fund/order/amount/chart/total",
    reportUsersCountAccount: "/core/bank/cards/countUsers",
    reportTransactionsDDCount: "/core/report/dd/transaction/total",
    reportTransactionsDDCountChart: "/core/report/dd/transaction/chart/total",
    transactionReceiptImage: (transaction_id) =>
        `/core/bankTransfer/image/${transaction_id}`,
    resendSellOrder: "/core/fund/sell/resend",
    cmsSellReportList: "/core/fund/getCmsSellOrderList",
    reportCardDaily: "/core/report/dd/withdraw/list",
    farabiBanks: "/core/funds/banks",
    updateTransactionBank: (transaction_id) =>
        `/core/updateOrderBuy/${transaction_id}`,
    customerFundsProfits: (customer_id, fund_id) =>
        `/core/user/${customer_id}/fund/${fund_id}/profit`,
    customerOrderList: (customer_id, fund_id) =>
        `/core/user/${customer_id}/report/list/fund/${fund_id}`,
    runRayanBuy: (fund_id) => `/core/run/jobs/rayanBuy/${fund_id}`,
    runUpdatesOrdersStatusAction: "/core/run/jobs/updatesOrdersStatus",
    getProfitIssuers: "/core/user/profitIssuers/list",
    updateProfitIssuer: (user_id) =>
        `/core/user/${user_id}/profitIssuers/update`,
    invitedUsersList: "/core/report/usersCountList",
    subsetTotalBuy: "/core/report/manager/total/buy",
    subsetTotalSell: "/core/report/manager/total/sell",
    disabledAccounts: "/core/report/bankCard/disabled",
    withdrawByNationalCodeJob: "/core/run/jobs/withdrawWithNationalCode",
    createPaymentLink: "/core/payments/links",
    deletePaymentLink: (uuid) => `/core/payments/links/${uuid}`,
    generatedLinks: "/core/payments/links",
    runWithdrawJob: "/core/run/jobs/dailyWithdraw",
    reportOrderTotalLink: "/core/report/fund/order/ipgOff/amount/total",
    reportOrdersTotalLinkChart:
        "/core/report/fund/order/ipgOff/amount/chart/total",
    updatePaymentLink: (uuid) => `/core/payments/links/${uuid}`,
    addPosTransaction: "/core/posTransaction",
    getPinvestPartners: "/core/pinvestPartners",
    resendPaymentLink: (id) => `/core/payments/links/resend/${id}`,
    runUpdateUserProfit: "/core/run/jobs/updateUserProfit",
    buyReceipt: "/core/bankTransfer",
    deleteOrder: (order_id) => `/core/orders/${order_id}`,
    customerSell: "/core/orders/sell",
    fundDetails: (fund_id) => `/core/fund/${fund_id}`,
    rejectReasons: "/core/attributes/rejection-reasons",
    getLinkQr: (identifier) => `/core/payment-links/files/${identifier}`,
    linkcommissionTotal: "/core/payment-links/commissions/total",
    linkCommissionChart: "/core/payment-links/commissions/chart",
    customerFundStatement: (user_id, fund_id) =>
        `/core/user/${user_id}/fund/${fund_id}/statement`,
    consultationsList: "/core/consultations/list",
    updateConsultationStatus: (id) => `/core/consultations/${id}`,
    sendBCard: "/core/message/BCardLink",
    bCardList: "/core/message/BCard/list",
    applySettings: "/core/config/apply",
    accountingCommissions: "/core/commissions",
    submitSettelments: "/core/settlements",
    settelmentsList: "/core/settlements",
    compass: "/core/report/compass",
    runRayanSell: (fund_id) => `/core/run/jobs/rayanSell/${fund_id}`,
    loginLogs: "/core/manager/logs",
    getBlogCategoires: "/core/blog/tag/list",
    addPost: "/core/blog/create",
    blogAddBodyImage: "/core/blog/image/insert",
    postsList: "/core/blog/privateList",
    getPost: (post_id) => `/core/blog/find/${post_id}`,
    updatePost: (post_id) => `/core/blog/update/${post_id}`,
    createBlogCategory: "/core/blog/tag/create",
    deleteBlogCategory: (id) => `/core/blog/tag/delete/${id}`,
    updateBlogCategory: (id) => `/core/blog/tag/update/${id}`,
    NPSList: "/core/nps/list",
    NPSCalculate: "/core/nps/calculate",
    assignPermission: (manager_id) => `/core/permission/assign/${manager_id}`,
    managerPermissionsList: (manager_id) =>
        `/core/permission/list/${manager_id}`,
    sendConsultationLink: "/core/message/sendConsultationTime",
    vouchersList: "/core/voucher",
    sendVoucher: "/core/voucher/create",
    deleteVoucher: (id) => `/core/voucher/${id}`,
    profitsMonth: (user_id, fund_id) =>
        `/core/user/${user_id}/fund/${fund_id}/monthlyProfit`,
    monthlyDeposit: (user_id, fund_id) =>
        `/core/user/${user_id}/fund/${fund_id}/monthlyDeposit`,
    profitsChart: (customer_id, fund_id) =>
        `/core/user/${customer_id}/fund/${fund_id}/dailyProfits`,
    depositsTable: (customer_id, fund_id) =>
        `/core/user/${customer_id}/fund/${fund_id}/dailyDeposit`,
    commissionsTable: (customer_id, fund_id) =>
        `/core/user/${customer_id}/fund/${fund_id}/dailyCommission`,
    commandMonitoring: "/core/commandMonitoring",
    downloadTemplate: "/core/downloadTemplateFile",
    voucherBatch: (fund_id) => `/core/voucher/batch/${fund_id}`,
    vouchersFailedList: "/core/voucher/failed",
    createCommand: "/core/commandMonitoring/scheduled/insert",
    scheduledCommands: "/core/commandMonitoring/scheduled",
    customersChart: "/core/user/chart",
    reportCustomersTotal: "/core/report/user/total",
    reportCustomersTotalChart: "/core/report/user/chart/total",
    customerWithFunds: "/core/report/fund/user/total",
    customerWithFundsChart: "core/report/fund/user/chart/total",
    reportRepeatedSells: "core/repeatSell",
    runSellDebitCalculatorJob: "/core/run/jobs/sellDebitCalculator",
    reportCMSOrders: "/core/report/cmsOrders",
    updateCMSOrderActiveState: "/core/cmsOrders",
    getMessageFilters: "/core/message/filters",
    getMessageUsersList: "/core/getUsers",
    updateOrderFund: (order_id) => `core/orders/buy-orders/${order_id}`,
    holidaysList: "/core/holidays",
    addHoliday: "/core/holidays",
    updateHoliday: (id) => `/core/holidays/${id}`,
    funds: "/core/funds",
    changeFundStatus: (fund_id) => `/core/funds/${fund_id}`,
    runShaparakCommissionCalculatorJob: "/core/commissions/ipg"
};

const blog_routes = {
    postsList: "/blog/list",
    getPost: (post_id) => `/blog/show/${post_id}`,
};

export default undefined;
export { admin_routes, blog_routes, user_routes };

